import React from 'react';
import { Link } from 'react-router-dom';
import rushLogo from './rush-logo.png';
import { RushThemeToggle } from './rushTheme';

// Maps Rush design's HTML links to our React Router paths.
// Keep the file names from the design as map keys so other ported pages can reuse this.
export const HREF_MAP = {
  'Rush Studio Landing.html': '/',
  'Features.html': '/features',
  'Languages.html': '/languages',
  'Integrations.html': '/integrations',
  'Pricing.html': '/pricing',
  'Customers.html': '/customers',
  'About.html': '/about',
  'Careers.html': '/careers',
  'Contact.html': '/contact',
  'Security.html': '/security',
  'Privacy.html': '/privacy',
  'Terms.html': '/terms',
  'GDPR.html': '/gdpr',
  'Sign In.html': '/login',
  'Sign Up.html': '/register',
  'Role Technical Writers.html': '/roles/technical-writers',
  'Role Marketing.html': '/roles/marketing',
  'Role Localization Managers.html': '/roles/localization-managers',
  'Role Product Managers.html': '/roles/product-managers',
  'Role Design Ops.html': '/roles/design-ops',
};

export const RushNav = ({ active }) => {
  return (
    <header className="rs-nav">
      <div className="rs-container">
        <div className="rs-nav-inner">
          <Link to="/" className="rs-logo rs-logo-img" aria-label="Rush Studio home">
            <img src={rushLogo} alt="Rush Studio" />
          </Link>
          <nav className="rs-nav-links">
            <Link to="/features" className={active === 'features' ? 'active' : ''}>Features</Link>
            <Link to="/languages" className={active === 'languages' ? 'active' : ''}>Languages</Link>
            <Link to="/integrations" className={active === 'integrations' ? 'active' : ''}>Integrations</Link>
            <Link to="/pricing" className={active === 'pricing' ? 'active' : ''}>Pricing</Link>
            <div className="rs-nav-drop">
              <button type="button" className={`rs-nav-trigger ${active === 'customers' ? 'active' : ''}`} aria-haspopup="menu">
                Customers
                <svg className="caret" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                  <path d="M2 4l3 3 3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <div className="rs-nav-menu" role="menu">
                <div className="rs-nav-menu-col">
                  <div className="rs-nav-menu-label">Overview</div>
                  <Link className="rs-nav-menu-item" to="/customers">
                    <span className="nm-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <circle cx="7" cy="5" r="2.4" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M2 12c.7-2.4 2.6-3.4 5-3.4s4.3 1 5 3.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                    </span>
                    <div className="nm-body">
                      <span className="nm-title">Early access</span>
                      <span className="nm-sub">Be one of our first teams</span>
                    </div>
                  </Link>
                  <div className="rs-nav-menu-cta">
                    <div className="nm-cta-title">Launching in 2027</div>
                    <div className="nm-cta-sub">Join early access and help shape Rush Studio.</div>
                    <Link className="nm-cta-link" to="/customers">Get early access →</Link>
                  </div>
                </div>
                <div className="rs-nav-menu-col">
                  <div className="rs-nav-menu-label">By role</div>
                  <Link className="rs-nav-menu-item" to="/roles/technical-writers">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 2h6l2 2v8H3z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /><path d="M5 6h4M5 8.5h4M5 11h2.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Technical writers</span><span className="nm-sub">Docs that translate on every PR</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/marketing">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 5.5L10 3v8L2.5 8.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /><path d="M4 8.5v2.5h2V9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Marketing teams</span><span className="nm-sub">Campaigns shipped in every market</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/localization-managers">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.4" /><path d="M2 7h10M7 2c1.6 1.5 1.6 8.5 0 10M7 2c-1.6 1.5-1.6 8.5 0 10" stroke="currentColor" strokeWidth="1.4" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Localization managers</span><span className="nm-sub">Run the whole pipeline from one screen</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/product-managers">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="2" y="3" width="10" height="8" rx="1.4" stroke="currentColor" strokeWidth="1.4" /><path d="M2 6h10M5 3v8" stroke="currentColor" strokeWidth="1.4" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Product managers</span><span className="nm-sub">UI strings, in-app copy, release notes</span></div>
                  </Link>
                  <Link className="rs-nav-menu-item" to="/roles/design-ops">
                    <span className="nm-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1.5L11.5 4v6L7 12.5 2.5 10V4z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /><path d="M7 1.5v11M2.5 4L11.5 10M11.5 4L2.5 10" stroke="currentColor" strokeWidth="1.4" /></svg></span>
                    <div className="nm-body"><span className="nm-title">Design ops</span><span className="nm-sub">Figma frames into 22 languages</span></div>
                  </Link>
                </div>
              </div>
            </div>
            <Link to="/contact" className={active === 'contact' ? 'active' : ''}>Contact</Link>
          </nav>
          <div className="rs-nav-cta">
            <RushThemeToggle />
            <Link className="btn btn-ghost-quiet btn-sm" to="/login">Sign in</Link>
            <Link className="btn btn-primary btn-sm" to="/register">Sign up</Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export const RushFooter = () => (
  <footer className="rs-footer">
    <div className="rs-container">
      <div className="rs-footer-grid">
        <div>
          <Link to="/" className="rs-logo rs-logo-img" style={{ marginBottom: 12 }} aria-label="Rush Studio">
            <img src={rushLogo} alt="Rush Studio" />
          </Link>
          <p style={{ color: 'var(--ink-3)', fontSize: 13, maxWidth: 280, margin: 0 }}>
            One translation dashboard for the whole localization pipeline. From upload to delivery, in 100+ languages.
          </p>
        </div>
        <div>
          <h5>Product</h5>
          <ul>
            <li><Link to="/">Dashboard</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/languages">Languages</Link></li>
            <li><Link to="/integrations">Integrations</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h5>Company</h5>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/customers">Customers</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h5>Resources</h5>
          <ul>
            <li>Docs</li>
            <li>Changelog</li>
            <li><Link to="/security">Security</Link></li>
            <li>Status</li>
          </ul>
        </div>
      </div>
      <div className="rs-footer-bottom">
        <span>© {new Date().getFullYear()} Rush Studio Ltd.</span>
        <span><Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link> · <Link to="/gdpr">DPA</Link></span>
      </div>
    </div>
  </footer>
);

// Hook: scroll-reveal animations (IntersectionObserver). Returns nothing; idempotent.
export const useRushReveal = () => {
  React.useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    const id = requestAnimationFrame(() => {
      document.querySelectorAll('.reveal, .stagger').forEach((el) => io.observe(el));
    });
    return () => { cancelAnimationFrame(id); io.disconnect(); };
  }, []);
};
